import RequestForm from "./RequestForm";
import { RootState } from "../../app/store";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import PageTemplate from "../../components/templates/PageTemplate";
import { useCreateRequestMutation } from "../../app/api";
import SuccessPage from "./SuccessPage";
import { useParams } from "react-router-dom";
import LoaderGlobal from "../../components/molecules/LoaderGlobal";
import { getFontClass } from "../../helpers/fontUtils";

const RequestsModule = () => {
  const params = useParams();
  const { requestsSettings } = useSelector(
    (state: RootState) => state.requests,
  );
  const { loading, generalSettings } = useSelector(
    (state: RootState) => state.generalSettings,
  );

  const [createRequest, { isSuccess }] = useCreateRequestMutation();

  if (loading || Object.keys(generalSettings).length === 0) {
    return <LoaderGlobal />;
  }

  return (
    <PageTemplate>
      {isSuccess ? (
        <SuccessPage fontFamily={generalSettings.events_styling.font_family} />
      ) : (
        <>
          <span
            style={{ margin: "0px 0px 10px 0px" }}
            className={`text-[32px]  font-normal mb-[10px] ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {globalThis.translate.em.request.title}
          </span>
          <span
            className={`text-base  text-[16px] ${getFontClass(generalSettings.events_styling.font_family)}`}
          >
            {globalThis.translate.em.request.subtitle}
          </span>
          <RequestForm
            createRequest={createRequest}
            requestsSettings={requestsSettings}
            id_room={params?.id_room}
          />
        </>
      )}
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </PageTemplate>
  );
};

export default RequestsModule;
